/* eslint-disable id-length */
import React from "react";
import Link from "helpers/link";

const BlogLinks = ({ children, value }) => <Link className="border-b border-gray-701" to={value.href}>{children}</Link>;
const HomepageLinks = ({ children, value }) => <Link className="underline" to={value.href}>{children}</Link>;
const NoStyleLinks = ({ children, value }) => <Link to={value.href}>{children}</Link>;

export const richTextTemplate = {
    Homepage: {
        block: {
            h1: ({ children }) => <h1 className="mb-8 mt-10 text-blue-700 font-normal">{children}</h1>,
            h2: ({ children }) => <h2 className="mb-8 mt-10 text-blue-700">{children}</h2>,
            h3withTick: ({ children }) => (
                <h3 className="flex gap-6 mb-4 text-blue-700">
                    <span> · </span>
                    {children}
                </h3>
            ),  
            h3: ({ children }) => <h3 className="mb-8 mt-10 text-blue-700">{children}</h3>,
            h4: ({ children }) => <h4 className="mb-8 mt-10 text-blue-700 font-normal">{children}</h4>,
            normal: ({ children }) => <p className="mb-4 text-[#444444] leading-6">{children}</p>,         
            normalWithTick: ({ children }) => (
                <p className="flex gap-6 mb-4 text-[#444444] ml-[5%]">
                    <span> . </span>
                    {children}
                </p>
            ),    
            span: ({ children }) => <span className="text-[#444444] leading-6">{children}</span>,
        },
        marks: {
            link: HomepageLinks,
            strong: ({ children }) => <strong className="text-[#444444] leading-7">{children}</strong>,
        },
        list: { bullet: ({ children }) => <ul className="text-[#444444]">{children}</ul> },
        listItem: {
            bullet: ({ children }) => (
                <li className="leading-7"> 
                    {children}
                </li>
            ), 
            number: ({ children }) => (
                <li className="leading-7"> 
                    {children}
                </li>
            ), 
        },
    },
    Blog: {
        block: {
            h1: ({ children }) => <h1 className="mb-8 text-blue-700">{children}</h1>,
            h2: ({ children }) => <h2 className="mb-8 text-blue-700">{children}</h2>,
            h3: ({ children }) => <h3 className="mb-4 lg:mb-8 mt-6 lg:mt-10 text-blue-700">{children}</h3>,
            h4: ({ children }) => <h4 className="mb-4 lg:mb-8 mt-6 lg:mt-10 text-blue-700">{children}</h4>,
            normal: ({ children }) => <p className="mb-4 text-[#444444]">{children}</p>,           
            span: ({ children }) => <span className="text-[#444444]">{children}</span>,
        },
        marks: {
            link: BlogLinks,
            strong: ({ children }) => <strong className="text-[#444444]">{children}</strong>,
        },
        list: {
            bullet: ({ children }) => <ul className="ml-9 text-[#444444] list-disc">{children}</ul>,
            number: ({ children }) => <ul className="ml-9 text-[#444444] list-decimal">{children}</ul>, 
        },
        listItem: {
            bullet: ({ children }) => (
                <li className="mb-1"> 
                    {children}
                </li>
            ),
            number: ({ children }) => (
                <li>                    
                    {children}
                </li>
            ),
        
        },
    },
    NoStyle: {
        block: {
            h1: ({ children }) => <h1>{children}</h1>,
            h2: ({ children }) => <h2>{children}</h2>,
            h3: ({ children }) => <h3>{children}</h3>,
            h4: ({ children }) => <h4>{children}</h4>,
            normal: ({ children }) => <p>{children}</p>,           
            span: ({ children }) => <span>{children}</span>,
        },
        marks: {
            link: NoStyleLinks,
            strong: ({ children }) => <strong>{children}</strong>,
        },
        list: {
            bullet: ({ children }) => <ul>{children}</ul>,
            number: ({ children }) => <ul>{children}</ul>, 
        },
        listItem: {
            bullet: ({ children }) => (
                <li> 
                    {children}
                </li>
            ),
            number: ({ children }) => (
                <li>                    
                    {children}
                </li>
            ),
        
        },
    },
};

export default richTextTemplate;
